export const ID = 'id';
export const DISPLAY_NAME = 'displayName';
export const CUSTOM_METRIC = 'customMetric';
export const METRIC_TYPE = 'type';
export const GROUP_ID = 'groupId';
export const IS_PUBLIC = 'isPublic';
export const IS_HIGHLIGHT_LOWER = 'isHighlightLower';
export const IS_ADVANCED_AVAILABLE = 'isAdvancedAvailable';
export const IS_AVAILABLE_FOR_CHART = 'isAvailableForChart';
export const IS_AVAILABLE_FOR_PARTNERS = 'isAvailableForPartners';
export const CHART_AXIS_GROUP_ID = 'chartAxisGroupId';
export const PARTNERS_AVAILABILITY = 'partnersAvailability';
export const PRECISION = 'precision';
export const DESCRIPTION = 'description';
